import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loading } from '../ui';

export default function RotaProtegida({ children }: { children: React.ReactNode }) {
  const { autenticado, carregando } = useAuth();
  if (carregando) return <Loading mensagem="Verificando autenticação..." />;
  if (!autenticado) return <Navigate to="/admin/login" replace />;
  return <>{children}</>;
}
